import { v4 as uuidv4 } from 'uuid';


export function getThreadId() {
    // Check if an ID already exists in localStorage
    const storedTabId = sessionStorage.getItem("tabId");
    if (storedTabId) {
        return storedTabId;
    } else {
        const newTabId = uuidv4();
        sessionStorage.setItem("tabId", newTabId);
        return newTabId;
  }
}

export const clearThreadId = () => {
    sessionStorage.removeItem("tabId");
  };



